import {useCallback, useEffect} from 'react';

const BLOCKED_EVENTS = new Set(['keydown', 'keyup']);

export const useStopPropagateKeyboardEvents = (open: boolean, keys: Set<string>): void => {
    const handleKeyboardEvent = useCallback<EventListener>(
        (e) => {
            if (keys.has((e as KeyboardEvent).key)) {
                e.stopPropagation();
            }
        },
        [keys]
    );

    useEffect(() => {
        if (open) {
            BLOCKED_EVENTS.forEach((event) => document.addEventListener(event, handleKeyboardEvent));
        }

        return () => {
            BLOCKED_EVENTS.forEach((event) => document.removeEventListener(event, handleKeyboardEvent));
        };
    }, [open, handleKeyboardEvent]);
};
